import { Link } from "react-router-dom";
import { Plus, Recycle } from "lucide-react";
import { toast } from "sonner";
import { useCart } from "../../context/CartContext";

export const ProductCard = ({ product }) => {
  const { addItem } = useCart();
  return (
    <div data-testid={`product-card-${product.slug}`} className="card-dish group bg-white rounded-2xl overflow-hidden border border-[#E7E0D8]">
      <Link to={`/prodotto/${product.slug}`} className="block">
        <div className="relative aspect-square overflow-hidden bg-[#F5F0EB]">
          <img src={product.image} alt={product.name} loading="lazy" className="dish-img w-full h-full object-cover" />
          <span data-testid={`eco-badge-${product.slug}`} className="absolute top-3 left-3 inline-flex items-center gap-1 rounded-full bg-[#FDFBF7]/95 backdrop-blur-sm text-[#2E8A57] px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wide shadow-sm">
            <Recycle className="w-3 h-3" /> Packaging riciclabile
          </span>
        </div>
      </Link>
      <div className="p-5">
        <p className="font-mono-accent text-[10px] uppercase tracking-[0.2em] text-[#3C6E53] mb-1.5">{product.category}</p>
        <Link to={`/prodotto/${product.slug}`}>
          <h3 className="font-serif-display font-semibold text-lg text-[#1C1917] leading-snug min-h-[3.2rem] hover:text-[#2E8A57] transition-colors">
            {product.name}
          </h3>
        </Link>
        <div className="mt-3 flex items-center justify-between">
          <span data-testid={`product-price-${product.slug}`} className="font-mono-accent font-semibold text-[#2E8A57]">
            {product.price.toFixed(2).replace(".", ",")} €
          </span>
          <button
            data-testid={`add-to-cart-${product.slug}`}
            onClick={() => {
              addItem(product);
              toast.success(`${product.name} aggiunto al carrello`);
            }}
            className="btn-tuscan w-9 h-9 rounded-full flex items-center justify-center"
            aria-label="Aggiungi al carrello"
          >
            <Plus className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};
